var map = {
	"./404.svg": "49be",
	"./Records.svg": "57e5",
	"./bb.svg": "facd",
	"./bba.svg": "1a28",
	"./bell.svg": "abae",
	"./biggoods.svg": "a9eb",
	"./bug.svg": "937c",
	"./build.svg": "b88c",
	"./bulkReceipt.svg": "8243",
	"./button.svg": "c292",
	"./c-Inquiry.svg": "1d21",
	"./c-Inventory.svg": "a038",
	"./c-cazhong.svg": "27fb",
	"./c-comparison.svg": "9aa1",
	"./c-m-material-add-receipt.svg": "ba6b",
	"./c-m-material-bulk-receipt.svg": "3628",
	"./c-material-bulk-settlement.svg": "5371",
	"./c-material-check.svg": "9a80",
	"./c-material-compare.svg": "c3c1",
	"./c-material-purchases-agreement.svg": "0f50",
	"./c-material-purchases-enquiry.svg": "8c2e",
	"./c-material-purchases-inquiry.svg": "b2cf",
	"./c-material-purchases-order.svg": "959c",
	"./c-material-purchases-request.svg": "70bb",
	"./c-material-retreat.svg": "4b8e",
	"./c-material-sporadic-receipt.svg": "ae97",
	"./c-material-sporadic-sapplications.svg": "d242",
	"./c-material-sporadic-settlement.svg": "ed57",
	"./c-material-transfer.svg": "dc3a",
	"./c-price Adjustment.svg": "b169",
	"./c-purchase order.svg": "3de9",
	"./c-receiving.svg": "d015",
	"./c-request.svg": "badc",
	"./c-returns.svg": "3b0c",
	"./c-settlement.svg": "7269",
	"./c-submission.svg": "77d8",
	"./c-termination.svg": "0bfb",
	"./c-transfer.svg": "660c",
	"./c-w-pay-management.svg": "4555",
	"./c-wx-checkoutPesticide.svg": "c16a",
	"./c-wx-enterWarehouse.svg": "5fb6",
	"./c-wx-freshPeelRecords.svg": "e39b",
	"./c-wx-pickingTasks.svg": "f2fc",
	"./c-wx-printingLabel.svg": "1902",
	"./c-wx-semiFinishedRecords.svg": "e200",
	"./c-wx-sourceTracing.svg": "ea32",
	"./c-wx-transportTasks.svg": "4755",
	"./c-wx-visitingTasks.svg": "cdbb",
	"./cc.svg": "c4a5",
	"./cca.svg": "d0a9",
	"./cg.svg": "494c",
	"./cga.svg": "d6fb",
	"./chart.svg": "20e7",
	"./clipboard.svg": "5aa7",
	"./cockpit.svg": "a2b0",
	"./component.svg": "02b8",
	"./consult.svg": "75d7",
	"./coordinates.svg": "b9bb",
	"./cw.svg": "f58d",
	"./cwa.svg": "3362",
	"./cz.svg": "35fc",
	"./cza.svg": "45a9",
	"./dashboard.svg": "7154",
	"./date-range.svg": "ad41",
	"./del-deatils.svg": "458d",
	"./document.svg": "2233",
	"./documentation.svg": "ed00",
	"./draft.svg": "209f",
	"./drag.svg": "a2f6",
	"./edit.svg": "2fb0",
	"./education.svg": "2369",
	"./email.svg": "caf7",
	"./example.svg": "b6f9",
	"./excel.svg": "e3ff",
	"./exit-fullscreen.svg": "f22e",
	"./expireTime.svg": "4eba",
	"./eye-open.svg": "74a2",
	"./eye.svg": "57fa",
	"./field.svg": "8295",
	"./fieldAttr.svg": "6adc",
	"./folder.svg": "5a71",
	"./folderBig.svg": "c3ab",
	"./for.svg": "f565",
	"./form.svg": "4576",
	"./fullscreen.svg": "72e5",
	"./g-Suppliers.svg": "fd48",
	"./g-supplier.svg": "bec9",
	"./guide.svg": "72d1",
	"./gy.svg": "cac0",
	"./gya.svg": "0810",
	"./h-agreement-agree.svg": "d44a",
	"./h-agreement-case.svg": "907a",
	"./h-agreement-contract.svg": "c103",
	"./h-agreement-stop.svg": "f641",
	"./hmos.svg": "d051",
	"./homeDate.svg": "28d1",
	"./homeModule.svg": "0873",
	"./icon.svg": "9f4c",
	"./international.svg": "a601",
	"./iphone.svg": "0a80",
	"./j-machinery-application.svg": "074c",
	"./j-machinery-approval.svg": "e28a",
	"./j-machinery-compare.svg": "0b72",
	"./j-machinery-contract.svg": "760c",
	"./j-machinery-drum.svg": "e947",
	"./j-machinery-entry.svg": "bfd8",
	"./j-machinery-hours.svg": "990d",
	"./j-machinery-inquiry.svg": "8979",
	"./j-machinery-jar.svg": "ec14",
	"./j-machinery-list.svg": "fe74",
	"./j-machinery-monitoring.svg": "c6c4",
	"./j-machinery-month.svg": "ec1e",
	"./j-machinery-oil.svg": "f12e",
	"./j-machinery-ordering.svg": "37b7",
	"./j-machinery-settlement.svg": "92f4",
	"./j-machinery-taiban.svg": "eee9",
	"./j-machinery-temporary-application.svg": "8a7b",
	"./j-machinery-temporary-settlement.svg": "a6ff",
	"./j-machinery-terminal.svg": "210b",
	"./j-machinery-transportation.svg": "fa2f",
	"./jg.svg": "424c",
	"./jga.svg": "ecd7",
	"./k.svg": "705f",
	"./ka.svg": "1e49",
	"./l-labour-advance.svg": "d833",
	"./l-labour-application.svg": "4449",
	"./l-labour-approval.svg": "9210",
	"./l-labour-attendance.svg": "1da5",
	"./l-labour-compare.svg": "e1e2",
	"./l-labour-group-manage.svg": "f94d",
	"./l-labour-inquiry.svg": "9031",
	"./l-labour-manage.svg": "dcdc",
	"./l-labour-moment-application.svg": "cf4b",
	"./l-labour-moment-entry.svg": "4bbc",
	"./l-labour-notes.svg": "6d0e",
	"./l-labour-settlement-moment.svg": "e4bc",
	"./l-labour-settlement.svg": "dd84",
	"./labor-approach.svg": "07be",
	"./labor-att-sign.svg": "88fa",
	"./labor-quantity-record.svg": "c39a",
	"./labor-team-mgt.svg": "f0a5",
	"./labor-temp-apply.svg": "92a8",
	"./labor-temp-entry.svg": "3b6c",
	"./language.svg": "a17a",
	"./link.svg": "5fda",
	"./list.svg": "3561",
	"./lock.svg": "a012",
	"./material.svg": "1dbb",
	"./materialsBill.svg": "949d",
	"./message.svg": "15e8",
	"./money.svg": "4955",
	"./monitor.svg": "f71f",
	"./nested.svg": "91be",
	"./offer.svg": "bcf2",
	"./organization.svg": "2347",
	"./password.svg": "198d",
	"./pay-baoxiao.svg": "5495",
	"./pay-management.svg": "5519",
	"./pay-order.svg": "99ee",
	"./pay-request.svg": "3643",
	"./pdf.svg": "8989",
	"./people.svg": "ae6e",
	"./peoples.svg": "dc13",
	"./plan.svg": "d796",
	"./procurement.svg": "0cba",
	"./project.svg": "f61c",
	"./qq.svg": "39e1",
	"./question.svg": "5d9e",
	"./r-achievements.svg": "0607",
	"./r-enter.svg": "2800",
	"./refresh.svg": "b41b",
	"./refused.svg": "9c0a",
	"./report.svg": "022e",
	"./search.svg": "679a",
	"./settle accounts.svg": "5845",
	"./settlement.svg": "21d8",
	"./shopping.svg": "98ab",
	"./size.svg": "879b",
	"./skill.svg": "a263",
	"./sporadic.svg": "5839",
	"./sporadicReceipt.svg": "285d",
	"./star.svg": "4e5a",
	"./sy.svg": "6c87",
	"./sya.svg": "2ef6",
	"./sygl.svg": "44e8",
	"./sygla.svg": "d841",
	"./system.svg": "922f",
	"./tab.svg": "2723",
	"./table.svg": "dc78",
	"./theme.svg": "7271",
	"./through.svg": "09b6",
	"./tool.svg": "06b3",
	"./tree-table.svg": "4d24",
	"./tree.svg": "0e8f",
	"./user.svg": "d88a",
	"./vertical.svg": "a837",
	"./view.svg": "5a17",
	"./wechat.svg": "2ba1",
	"./window.svg": "1045",
	"./xt.svg": "75da",
	"./xta.svg": "ef29",
	"./z-Payment Management.svg": "a8f2",
	"./zip.svg": "a75d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";